import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import '@/styles/UI/Dices3d.less';
import DiceBox from '@3d-dice/dice-box';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from '@/assets/icons/LibrarySvg';
import { useAuth } from '@/context/AuthContext';
const DiceBar = ({ pageButtonsContainer, showToggleButton = true }) => {
    const diceBoxRef = useRef(null);
    const [lastDiceResult, setLastDiceResult] = useState(null);
    const { loading } = useAuth();
    const handleRollComplete = (rollResults) => {
        // console.log('onRollComplete rollResults', rollResults);
        const lastRollResult = rollResults[rollResults.length - 1];
        // console.log('onRollComplete lastRollResult', lastRollResult);
        setLastDiceResult({
            title: `${lastRollResult.qty}d${lastRollResult.sides}`,
            result: lastRollResult.value,
            rolls: lastRollResult.rolls.map((dieResult) => dieResult.result),
        });
    };
    useEffect(() => {
        if (loading)
            return;
        const diceBox = new DiceBox('#dice-box', {
            assetPath: '/assets/dice-box/', // required
            // theme: 'default-smooth',
            theme: 'default',
            offscreen: true,
            scale: 4,
            gravity: 5,
            mass: 0.5,
            friction: 0.8,
            restitution: 0,
            linearDamping: 0.5,
            angularDamping: 0.4,
            spinForce: 4,
            throwForce: 7,
            startingHeight: 4,
            themeColor: '#0f598a',
        });
        diceBox.init().then(() => {
            // console.log(' ~ ~ ~ DiceBox initialized ~ ~ ~ ');
            diceBox.onRollComplete = handleRollComplete;
            diceBoxRef.current = diceBox;
        });
        return () => {
            var _a;
            (_a = diceBoxRef.current) === null || _a === void 0 ? void 0 : _a.clear();
            diceBoxRef.current = null;
        };
    }, [loading]);
    useEffect(() => { }, [lastDiceResult]);
    const handleDiceThrow = (diceName, count = 1, modifier = 0) => {
        var _a, _b;
        const rollObject = {
            modifier: modifier,
            qty: count,
            sides: Number(diceName.split('d')[1]),
            // themeColor: '#89d0ff',
        };
        setLastDiceResult(null);
        (_a = diceBoxRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        (_b = diceBoxRef.current) === null || _b === void 0 ? void 0 : _b.roll(rollObject).then((result) => {
            console.log('Dice roll result:', result);
            console.log('------');
            // socket -> GM / player roll the dice.
            // socket -> results / add log (if settings true).
        });
    };
    const toggleDiceBar = () => {
        const diceBar = document.querySelector('.dice-bar');
        if (diceBar) {
            diceBar.classList.toggle('show');
        }
    };
    const handleCopyResult = () => {
        var _a;
        if (lastDiceResult) {
            navigator.clipboard.writeText(`${lastDiceResult.result}`);
            setLastDiceResult(null);
            toggleDiceBar();
            (_a = diceBoxRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        }
    };
    return (_jsxs(_Fragment, { children: [lastDiceResult && (_jsxs("div", { className: "throw-result-container", children: [_jsxs("div", { className: "text-container", children: [_jsxs("span", { className: "title", children: [lastDiceResult === null || lastDiceResult === void 0 ? void 0 : lastDiceResult.title, ":"] }), _jsx("span", { className: "result", children: lastDiceResult === null || lastDiceResult === void 0 ? void 0 : lastDiceResult.result })] }), _jsxs("div", { className: "buttons-container", children: [_jsx("button", { className: "copy-result", onClick: handleCopyResult, children: "Copy" }), _jsx("button", { className: "copy-result", onClick: handleCopyResult, children: "Close" })] })] })), _jsxs("div", { className: "dice-bar", children: [_jsx("button", { className: "throw-dice-btn", onClick: () => handleDiceThrow('1d100'), children: _jsx("div", { className: "dice-icon", children: _jsx(Icon, { name: "d100" }) }) }), _jsx("button", { className: "throw-dice-btn", onClick: () => handleDiceThrow('2d20'), children: _jsx("div", { className: "dice-icon", children: _jsx(Icon, { name: "d20" }) }) }), _jsx("button", { className: "throw-dice-btn", onClick: () => handleDiceThrow('1d12'), children: _jsx("div", { className: "dice-icon", children: _jsx(Icon, { name: "d12" }) }) }), _jsx("button", { className: "throw-dice-btn", onClick: () => handleDiceThrow('1d10'), children: _jsx("div", { className: "dice-icon", children: _jsx(Icon, { name: "d10" }) }) }), _jsx("button", { className: "throw-dice-btn", onClick: () => handleDiceThrow('1d8'), children: _jsx("div", { className: "dice-icon", children: _jsx(Icon, { name: "d8" }) }) }), _jsx("button", { className: "throw-dice-btn", onClick: () => handleDiceThrow('1d6'), children: _jsx("div", { className: "dice-icon", children: _jsx(Icon, { name: "d6" }) }) }), _jsx("button", { className: "throw-dice-btn", onClick: () => handleDiceThrow('1d4'), children: _jsx("div", { className: "dice-icon", children: _jsx(Icon, { name: "d4" }) }) })] }), _jsx("div", { id: "dice-box" }), pageButtonsContainer &&
                showToggleButton &&
                createPortal(_jsx("button", { className: "dice-bar-toggle-btn", style: { order: 100 }, title: "Toggle Dice Bar", onClick: toggleDiceBar, children: _jsx(Icon, { name: "dice_3" }) }), pageButtonsContainer)] }));
};
export default DiceBar;
